import { render, staticRenderFns } from "./PeopleIdea.vue?vue&type=template&id=01ef1c3f&"
import script from "./PeopleIdea.vue?vue&type=script&lang=js&"
export * from "./PeopleIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports